module.exports = {
    application_key: "Aplikačný kľúč",
    network_key: "Sieťový kľúč",
    echo: "Echo interval",
    alive: "Alive interval",
    power_scale: "Výkonová škála",
    time_scale: "Časová škála",
    active_channels: "Aktívne kanály",
    accuracy: "Presnosť",
    select_all: "Označ všetky",
    new_test_profile: "Nový testovací profil",
    new_group: "Nová skupina",
    energy_offset: "Energetická kompenzácia",
    transformation_ratio: "Transformačný pomer",
    add_tag: "Pridaj tag...",
    search: "Vyhľadávanie",
    number_of_rows: "Počet riadkov",
    write_note: "Pridaj poznámku",
    value: "Hodnota",
    security: "Zabezpečenie",
    IP_settings: "Nastavenie IP adresy",
    IP_address: "IP adresa",
    network_mask: "Maska podsiete",
    gateway: "Brána",
    active_power_threshold: "Hranica pre činný výkon",
    map_name: "Názov mapy",
    group_name: "Názov skupiny",
    device_select: "Výber zariadenia",
    relay_select: "Výber relé",
    notification_source: "Druh notifikácie",
    notification_destination: "Umiestnenie notifikácie"
}